import { createContext } from 'react'

export const DraftsStorage = createContext({
  getItem: draftId => Promise.resolve(void draftId),
  setItem: (draftId, draft) => Promise.resolve(draft),
})
